export default {
  performance: {
    listTitleTable: {
      TICKER: 'TICKER',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE_1DAY: '1 DAY',
      PERCENT_PRICE_CHANGE_1WEEK: '1 WEEK',
      PERCENT_PRICE_CHANGE_2WEEK: '2 WEEKS',
      PERCENT_PRICE_CHANGE_1MONTH: '1 MONTH',
      PERCENT_PRICE_CHANGE_3MONTH: '3 MONTHS',
      PERCENT_PRICE_CHANGE_6MONTH: '6 MONTHS',
      PERCENT_PRICE_CHANGE_9MONTH: '9 MONTHS',
      PERCENT_PRICE_CHANGE_1YEAR: '1 YEAR',
      PERCENT_PRICE_CHANGE_YTD: 'YTD',
    },
  },
  overview: {
    overviewHeader: {
      TICKER: 'TICKER',
      PRICE: 'PRICE',
      CHANGE_PRICE: 'CHANGE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      VOLUME: 'VOLUME',
      AVG_VOLUME: 'AVG. VOLUME',
      RTD11: 'MARKET CAP (BN.)',
      RANKING: 'RANKING',
      PB: 'P/B',
      PE: 'P/E',
    },
  },
  financial: {
    financialHeader: {
      ticker: 'TICKER',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      ISA3: 'REVENUE (BN.) (TTM)',
      ISA20: 'NET PROFIT (BN.) (TTM)',
      RTD14: 'EPS (TTM)',
      RTD7: 'BVPS (VND)',
      RTD21: 'P/E',
      RTD25: 'P/B',
    },
  },
  technical: {
    technicalHeader: {
      TICKER: 'TICKER',
      VOLUME: 'VOLUME',
      PRICE: 'PRICE',
      PERCENT_PRICE_CHANGE: '% 1D CHANGE',
      SMA20: 'SMA20',
      SMA50: 'SMA50',
      SMA100: 'SMA100',
      RSI: 'RSI',
      CANDLE_STICK: 'CANDLESTICK',
    },
  },

  timeRangeList: {
    OneWeek: '5 days',
    TwoWeeks: '10 days',
    OneMonth: '20 days',
  },

  rateList: {
    OnePointTwo: '1.2',
    OnePointFive: '1.5',
    Two: '2',
    Five: '5',
    Ten: '10',
  },

  filterContent: {
    part_1: 'The ratio of Current Volume to Average Volume in',
    part_2: 'is more than',
    part_3: 'times',
    apply: 'APPLY',
  },
};
